export default class MissingPolicyMethodException extends Error {
    constructor(message) {
        super(message);
        this.name = 'MissingPolicyMethodException';
        this.logging = true;
    }
}
